<template>
  <div v-if="relatedArticlesShowcase && relatedArticlesShowcase.length">
    <div class="text-h5 mb-4">
      {{
        articleGetters.getArticleShowcaseSectionTitle(article) ||
        $t('magazine.articlePage.relatedArticles.sectionTitle')
      }}
    </div>
    <div class="flex gap-6 md:gap-4 flex-col md:flex-row flex-wrap">
      <NuxtLink
        v-for="(item, i) in relatedArticlesShowcase"
        :key="`related-article-card-${i}`"
        :to="item.link"
        class="flex-1 group md:block"
        :class="{
          hidden: i > 1,
        }"
      >
        <div class="aspect-4/3 w-full overflow-hidden rounded-[10px]">
          <img
            v-if="item.imageUrl"
            :src="item.imageUrl"
            :alt="item.title"
            class="object-cover h-full w-full duration-300 ease-in-out group-hover:scale-105"
          />
          <div v-else class="bg-gray-200 w-full h-full"></div>
        </div>

        <div
          class="text-sm leading-5 font-normal mt-2 group-hover:text-teal-600"
        >
          {{ item.title }}
        </div>
      </NuxtLink>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { ComputedRef } from 'vue'
import type { StrapiMagazineArticle } from '~/composables/types/strapi/strapi-magazine'

const article = inject('article') as ComputedRef<StrapiMagazineArticle>

const articles = articleGetters.getArticleShowcaseArticles(article?.value)

const $fullLocalizedUrl = useFullLocalizedUrl()

const relatedArticlesShowcase = computed(
  () =>
    articles?.map((article) => ({
      title: articleGetters.getTitle(article),
      imageUrl: articleGetters.getHeaderImageUrl(article),
      link: $fullLocalizedUrl(`/magazine/${articleGetters.getSlug(article)}`),
    })) || []
)
</script>
